import React, { useRef, useEffect } from 'react';
import Chart from 'chart.js/auto';
import moment from 'moment';

const DoughnutChart = ({priorityCount, allProjectDashboard}) => {

  // Normalize priority names to remove duplicates
  const normalizePriorityCount = (priorityCount) => {
    if (!priorityCount) return {};
    
    const normalized = {};
    
    Object.entries(priorityCount).forEach(([name, value]) => {
      // Normalize the name (convert to title case and handle special cases)
      let normalizedName = name.toLowerCase();
      
      // Handle special cases
      if (normalizedName.includes('blocker level 1') || normalizedName === 'blocker') {
        normalizedName = 'Blocker Level 1';
      } else if (normalizedName.includes('blocker level 2')) {
        normalizedName = 'Blocker Level 2';
      } else if (normalizedName === 'major') {
        normalizedName = 'Major';
      } else if (normalizedName === 'medium') {
        normalizedName = 'Medium';
      } else if (normalizedName === 'minor') {
        normalizedName = 'Minor';
      } else {
        // Capitalize first letter for other cases
        normalizedName = name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
      }
      
      // Add to normalized object, combining duplicates
      if (normalized[normalizedName]) {
        normalized[normalizedName] += value;
      } else {
        normalized[normalizedName] = value;
      }
    });
    
    return normalized;
  };

  const normalizedPriorityCount = normalizePriorityCount(priorityCount);
  const priorityArray = Object.entries(normalizedPriorityCount || {})?.map(([name, value]) => ({ name, value }));
  const chartRef = useRef(null);
  const chartInstanceRef = useRef(null);
  const sum = priorityArray.reduce((accumulator, obj) => accumulator + obj.value, 0);

  // Check if there are any tasks
  const hasTasks = sum > 0;

  useEffect(() => {
    if (chartInstanceRef.current) {
      chartInstanceRef.current.destroy();
    }
    drawChart();
  }, [priorityCount]);

let colorArray = [];
// Different shades of blue for priority chart
let colorAr = ['#1e3a8a', '#3b82f6', '#60a5fa', '#93c5fd', '#dbeafe', '#1e40af', '#1d4ed8', '#2563eb'];

function generateRandomBlueColor() {
  // Generate different shades of blue instead of random colors
  const blueShades = ['#1e3a8a', '#3b82f6', '#60a5fa', '#93c5fd', '#dbeafe', '#1e40af', '#1d4ed8', '#2563eb', '#1e3a8a', '#3b82f6'];
  const randomIndex = Math.floor(Math.random() * blueShades.length);
  return blueShades[randomIndex];
}

for (let i = 0; i < priorityArray.length; i++) {
  const blueColor = generateRandomBlueColor();
  colorArray.push(blueColor);
}
  const drawChart = () => {
    const chartCanvas = chartRef.current.getContext('2d');
    
    // If no tasks, show empty chart with 0
    if (!hasTasks) {
      chartInstanceRef.current = new Chart(chartCanvas, {
        type: 'doughnut',
        data: {
          labels: ['No Tasks'],
          datasets: [
            {
              label: '',
              data: [1],
              borderColor: 'transparent',
              backgroundColor: ['#f0f0f0'], // Light gray for no tasks
            },
          ],
        },
        options: {
          cutout: '70%',
          spacing: 0,
          plugins: {
            legend: {
              display: false, // Hide legend for no tasks
            },
            tooltip: {
              enabled: false, // Disable tooltip for no tasks
            },
          },
          responsive: true,
          maintainAspectRatio: false,
        },
        plugins: [{
          beforeDraw: function(chart) {
            var width = chart.width,
                height = chart.height,
                ctx = chart.ctx;
                ctx.restore();
                var fontSize = "3";
                ctx.font = fontSize + "em sans-serif";
                ctx.textBaseline = "middle";
                ctx.fillStyle = "white";
                var text = "0",
                textX = Math.round((width - ctx.measureText(text).width) / 2),
                textY = height / 2 - 20;
                ctx.fillText(text, textX, textY);
                ctx.save();
          }   
        }]
      });
      return;
    }
    
    chartInstanceRef.current = new Chart(chartCanvas, {
      type: 'doughnut',
      data: {
        labels : priorityArray.map((item)=> item.name),
        datasets: [
          {
            label: '',
            data: priorityArray.map((item)=> item.value),
            borderColor: 'transparent',
            backgroundColor: (priorityArray.length >= 5) ? colorAr : colorArray,
          },
        ],
      },

      options: {
        cutout: '70%',
        spacing: 0,
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              usePointStyle: true,
              padding: 20,
              font: {
                size: 12,
              },
            },
          },
          tooltip: {
            callbacks: {
              label: function(context) {
                const label = context.label || '';
                const value = context.parsed;
                const total = context.dataset.data.reduce((a, b) => a + b, 0);
                const percentage = ((value / total) * 100).toFixed(1);
                return `${label}: ${value} (${percentage}%)`;
              }
            }
          }
        },
        responsive: true,
        maintainAspectRatio: false,
      },
      plugins: [{
        beforeDraw: function(chart) {
          var width = chart.width,
              height = chart.height,
              ctx = chart.ctx;
              ctx.restore();
              var fontSize = "3";
              ctx.font = fontSize + "em sans-serif";
              ctx.textBaseline = "middle";
              ctx.fillStyle = "white";
              var text = `${sum}`,
              textX = Math.round((width - ctx.measureText(text).width) / 2),
              textY = height / 2 - 20;
              ctx.fillText(text, textX, textY);
              ctx.save();
        }   
      }]
    });
  };

  return (
    <div className='project_dashboard_chart p-2'>
      <p className='mb-0 text-white'>Tasks by Priority</p>
      <div className='doughnut_chart_container p-1'>
        <canvas ref={chartRef} className='myDashboard_doughnut_chart' />
      </div>
    </div>
  );
};

export default DoughnutChart;